import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './Default.css';

function Sidebar({ onLinkClick, permissions }) {
  const location = useLocation();

  const renderNavLink = (to, label) => (
    <Nav.Item className={`nav-item ${label.toLowerCase()}`}>
      <Nav.Link
        as={Link}
        to={to}
        className={location.pathname === to ? 'active' : ''}
        onClick={onLinkClick}
      >
        {label}
      </Nav.Link>
    </Nav.Item>
  );

  return (
    <div className="sidebar-content">
      {/* <div id="scanButton" style={{ margin: 0, padding: 0, width: '100%' }}>
        {permissions.includes('scan') && (
          <Nav.Item className="nav-item scan">
            <Nav.Link as={Link} to="/dashboard/scan" onClick={onLinkClick}>
              Scan
            </Nav.Link>
          </Nav.Item>
        )}
      </div> */}
   
      <Nav variant="" className="flex-column nav-items m-2 ">
        {permissions.includes('home') && renderNavLink('/dashboard', 'Home')}
        {permissions.includes('employees') && renderNavLink('/dashboard/employees', 'Employees')}
        {permissions.includes('items') && renderNavLink('/dashboard/items', 'Items')}
        {/* {permissions.includes('registertag') && renderNavLink('/dashboard/registertag', 'Register Tags')} */}
        {permissions.includes('warehouse') && renderNavLink('/dashboard/warehouse', 'WareHouse')}
        {permissions.includes('reports') && renderNavLink('/dashboard/reports', 'Reports')}
      </Nav>
    </div>
  );
}

export default Sidebar;
